import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";
import { UserRound, HeartHandshake, X } from "lucide-react";

export const CustomerPicker = ({ value, memberId, onChange }) => {
  const [members, setMembers] = useState([]);
  const [recent, setRecent] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    api.get("/club/members").then((r) => setMembers(r.data.filter((m) => m.active))).catch(() => {});
    api.get("/customers").then((r) => setRecent(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    const h = (e) => box.current && !box.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const q = value.trim().toLowerCase();
  const memberHits = members.filter((m) => !q || m.name.toLowerCase().includes(q) || m.phone.includes(q)).slice(0, 6);
  const memberNames = new Set(members.map((m) => m.name.toLowerCase()));
  const recentHits = recent.filter((c) => !memberNames.has(c.name.toLowerCase()) && (!q || c.name.toLowerCase().includes(q))).slice(0, 5);
  const selected = members.find((m) => m.id === memberId);

  return (
    <div className="relative" ref={box}>
      <div className="relative">
        <Input placeholder="Müşteri adı yazın veya kulüp üyesi seçin…" value={value} maxLength={120} data-testid="customer-name"
          onFocus={() => setOpen(true)} onChange={(e) => { onChange(e.target.value, null); setOpen(true); }} className={`h-9 ${selected ? "pr-8 border-primary/60" : ""}`} />
        {value && (
          <button type="button" className="absolute right-2 top-2 text-muted-foreground hover:text-foreground" data-testid="customer-clear" onClick={() => onChange("", null)}><X className="h-4 w-4" /></button>
        )}
      </div>
      {selected && (
        <p className="mt-1 flex items-center gap-1 text-xs text-primary" data-testid="customer-member-badge">
          <HeartHandshake className="h-3 w-3" /> Kulüp üyesi · {selected.meals_left} öğün kaldı{selected.balance > 0 ? ` · bakiye ₺${selected.balance.toLocaleString("tr-TR", { timeZone: "Europe/Istanbul" })}` : ""}
        </p>
      )}
      {open && (memberHits.length > 0 || recentHits.length > 0) && (
        <div className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-border bg-popover shadow-lg" data-testid="customer-suggestions">
          {memberHits.length > 0 && <p className="px-3 pt-2 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Kulüp Üyeleri</p>}
          {memberHits.map((m) => (
            <button key={m.id} type="button" data-testid={`customer-member-${m.id}`} className="flex w-full items-center justify-between px-3 py-1.5 text-left text-sm hover:bg-secondary"
              onClick={() => { onChange(m.name, m.id); setOpen(false); }}>
              <span className="flex items-center gap-2"><HeartHandshake className="h-3.5 w-3.5 text-primary" /> {m.name}</span>
              <span className="text-xs text-muted-foreground">{m.meals_left} öğün</span>
            </button>
          ))}
          {recentHits.length > 0 && <p className="px-3 pt-2 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">Önceki Müşteriler</p>}
          {recentHits.map((c) => (
            <button key={c.name} type="button" data-testid={`customer-recent-${c.name}`} className="flex w-full items-center justify-between px-3 py-1.5 text-left text-sm hover:bg-secondary"
              onClick={() => { onChange(c.name, null); setOpen(false); }}>
              <span className="flex items-center gap-2"><UserRound className="h-3.5 w-3.5" /> {c.name}</span>
              <span className="text-xs text-muted-foreground">{c.sales_count} satış</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
